import { elaAppProxy, elaAppProxyBody } from './index';
// proxy/ela/app/
// proxyBody/ela/app/

/* [ 모든문서 ] */
// 내문서함 목록조회
function getMyBoxList(params) {
  return elaAppProxy.get('mybox/list', { params });
}

/* [ 모든문서 ] */
// 휴일사전근무취소신청 목록조회
function holReplaceCancelBoxList(params) {
  return elaAppProxy.get('holreplace/box/list', { params });
}

// 근태/휴가 취소신청 목록조회
function vacationCancelBoxList(params) {
  return elaAppProxy.get('vacation/box/list', { params });
}

// 결재할문서 목록조회
function getApprDocList(params) {
  return elaAppProxy.get('appr/list', { params });
}

// 결재할문서 결재
function postApplConfirm(params) {
  return elaAppProxyBody.post('appl/confirm', params);
}

// 설문조사 목록조회
function surveyBoxList(params) {
  return elaAppProxy.get('survey/box/list', { params });
}

export {
  getMyBoxList,
  getApprDocList,
  postApplConfirm,
  holReplaceCancelBoxList,
  surveyBoxList,
  vacationCancelBoxList,
};
